module.exports = __webpack_public_path__ + "img/gzy.3a722a12.png";